export interface HapticEnvironment {
  vibrate?: ((pattern: number) => boolean) | undefined;
  userAgent: string;
  maxTouchPoints: number;
  document?: Document;
}

const tapMs = 10;

export function isAppleTouch(env: Pick<HapticEnvironment, 'userAgent' | 'maxTouchPoints'>): boolean {
  return (
    /iPhone|iPad|iPod/.test(env.userAgent) || (/Macintosh/.test(env.userAgent) && env.maxTouchPoints > 1)
  );
}

function browserEnvironment(): HapticEnvironment | null {
  if (typeof navigator === 'undefined' || typeof document === 'undefined') return null;
  return {
    vibrate: typeof navigator.vibrate === 'function' ? navigator.vibrate.bind(navigator) : undefined,
    userAgent: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints ?? 0,
    document,
  };
}

function switchTap(doc: Document): void {
  const label = doc.createElement('label');
  label.setAttribute('aria-hidden', 'true');
  label.style.display = 'none';
  const input = doc.createElement('input');
  input.type = 'checkbox';
  input.setAttribute('switch', '');
  input.tabIndex = -1;
  label.appendChild(input);
  doc.head.appendChild(label);
  try {
    label.click();
  } finally {
    label.remove();
  }
}

export function tapFeedback(
  env: HapticEnvironment | null = browserEnvironment(),
): 'vibrate' | 'switch' | 'none' {
  if (!env) return 'none';
  if (env.vibrate) {
    env.vibrate(tapMs);
    return 'vibrate';
  }
  if (env.document && isAppleTouch(env)) {
    switchTap(env.document);
    return 'switch';
  }
  return 'none';
}
